import Crwn from "../assets/portfolio/Crwn.jpg";
import Tango from "../assets/portfolio/Tango.jpg";
import Chumkin from "../assets/portfolio/Chumkin.jpg";
import BCPrediction from "../assets/portfolio/BCPrediction.jpg";
import CPPrediction from "../assets/portfolio/CPPrediction.jpg";
import HDPrediction from "../assets/portfolio/HDPrediction.jpg";
import uberData from "../assets/projects_image/UberAnalytics.png";
import BloodLink from "../assets/projects_image/BloodLink.png";
import HealthStack from "../assets/projects_image/HealthStack.png";
import LOS from "../assets/projects_image/Lifetime_of_servers.png";
import RTSM from "../assets/projects_image/realtime_stockmarket.png";
import RealEstate from "../assets/projects_image/RealEstate.png";

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    img: uberData,
    title: "Uber Data Analytics",
    desc: "This project analyzes Uber trip data, processes it using a star schema design, and stores it in a structured format for efficient querying and insights.",
    // demo: "https://sgcr7crwn-live.herokuapp.com/",
    source: "https://github.com/Adhoni/Uber-Data-Analytics",
  },
  {
    img: RTSM,
    title: "Real Time stock market analysis",
    desc: "This Real-Time Stock Market Analysis project uses Kafka to stream live stock market data to AWS S3, enabling efficient storage and processing of large-scale financial datasets. It integrates data pipelines for real-time analysis.",
    // demo: "https://github.com/MSAC-KIIT/TangoBrowser/blob/main/README.md",
    source: " https://github.com/Adhoni/Real-Time-Stock-Market-Data-Analysis",
  },
  {
    img: RealEstate,
    title: " Real Estate Price Prediction",
    desc: "This project predicts house prices in Bangalore using multiple regression models such as Linear, Ridge, and Lasso Regression. The model evaluates user inputs like area, BHK, bathrooms, and location to estimate the property price with high accuracy.",
    // demo: "https://github.com/sagnikghoshcr7/Chumkin/blob/master/README.md",
    source: "https://github.com/Adhoni/Real-Estate-Price-Prediction-Website",
  },
  {
    img: BloodLink,
    title: "BloodLink",
    desc: "BloodLink is a comprehensive web application built using the MERN (MongoDB, Express.js, React, Node.js) stack. It streamlines the management of blood donation activities by catering to different user roles such as admin, donor, hospital, and organization.                                                                                                     ",
    // demo: "https://github.com/sagnikghoshcr7/Breast-Cancer-Prediction/blob/master/model.ipynb",
    source: "https://github.com/Adhoni/BloodLink",
  },
  {
    img: LOS,
    title: "Lifetime extension of DataServers",
    desc: "This project analyzes the potential carbon reduction from extending the lifespan of datacenter servers or repairing them when needed, based on various data scenarios.",
    demo: "https://github.com/sagnikghoshcr7/Car-Price-Prediction/blob/master/Predicting%20used%20car%20prices.ipynb",
    source: " https://github.com/Adhoni/Ext-lifetime-of-datacenter-servers",
  },
  {
    img: HealthStack,
    title: "Health System",
    desc: "An online platform for hospitals to efficiently track, monitor, and share patient health records. Patients can access hospital and doctor information, book appointments, purchase medicines, pay for lab tests, and chat with their doctors, all in one place.",
    demo: "https://github.com/sagnikghoshcr7/Heart-Disease-Prediction/blob/master/Heart%20Disease%20Prediction.ipynb",
    source: " https://github.com/Adhoni/Health-System",
  },
];
